export enum Role {
    TEACHER = "teacher",
    STUDENT = "student",
}

export const QuestionOrigin = [
    { originType: 'AI', originName: 'DeepSeek'},
    { originType: 'AI', originName: 'Gemini'},
    { originType: 'AI', originName: 'Poe'},
    { originType: 'AI', originName: 'Poe Assistant'},
    { originType: 'AI', originName: 'ByteDance'},
    { originType: 'School', originName: 'ELCHK Lutheran Secondary School'},
    { originType: 'School', originName: 'Tsang Pik Shan (Sung Lan) Secondary School'},
    { originType: 'School', originName: 'HKTA The Yuen Yuen Institute No.1 Secondary School'},
    { originType: 'School', originName: 'Fanling Kau Yan College'},
    { originType: 'School', originName: 'Baptist Wing Lung Secondary School'},
    { originType: 'School', originName: 'SPHRC Kung Yik She Secondary School'},
    { originType: 'School', originName: 'C.C.C. Mong Wong Far Yok Memorial Primary School'},
    { originType: 'School', originName: 'Caritas Chong Yuet Ming Secondary School'},
    // { originType: 'School', originName: 'eduhk'},
];

export const Press = [
    { name: '聯合出版社', nameEn: 'SUP'},
    { name: '聯合出版社', nameEn: 'United Prime'},
    { name: '教育出版社', nameEn: 'EPH'},
];

// School mapping: English name (value) -> Chinese name (display)
export const SCHOOLS = [
  { value: "ELCHK Lutheran Secondary School", zhHK: "基督教香港信義會信義中學", en: "ELCHK Lutheran Secondary School" },
  { value: "Tsang Pik Shan (Sung Lan) Secondary School", zhHK: "曾璧山(崇蘭)中學", en: "Tsang Pik Shan (Sung Lan) Secondary School" },
  { value: "HKTA The Yuen Yuen Institute No.1 Secondary School", zhHK: "香港道教聯合會圓玄學院第一中學", en: "HKTA The Yuen Yuen Institute No.1 Secondary School" },
  { value: "Fanling Kau Yan College", zhHK: "粉嶺救恩書院", en: "Fanling Kau Yan College" },
  { value: "Baptist Wing Lung Secondary School", zhHK: "浸信會永隆中學", en: "Baptist Wing Lung Secondary School" },
  { value: "SPHRC Kung Yik She Secondary School", zhHK: "十八鄉鄉事委員會公益社中學", en: "SPHRC Kung Yik She Secondary School" },
  { value: "The Mission Covenant Church Holm Glad College", zhHK: "基督教聖約教會堅樂中學", en: "The Mission Covenant Church Holm Glad College" },
  { value: "Hong Kong Sea School", zhHK: "香港航海學校", en: "Hong Kong Sea School" },
  { value: "Chung Sing Benevolent Society Mrs Aw Boon Haw Secondary School", zhHK: "鐘聲慈善社胡陳金枝中學", en: "Chung Sing Benevolent Society Mrs Aw Boon Haw Secondary School" },
  { value: "C.C.C. Mong Wong Far Yok Memorial Primary School", zhHK: "中華基督教會蒙黃花沃紀念小學", en: "C.C.C. Mong Wong Far Yok Memorial Primary School" },
  { value: "Caritas Chong Yuet Ming Secondary School", zhHK: "明愛莊月明中學", en: "Caritas Chong Yuet Ming Secondary School" },
  { value: "Hong Kong Testing School for Test", zhHK: "測試賬號學校", en: "Hong Kong Testing School for Test" },
  { value: "eduhk", zhHK: "香港教育大學", en: "The Education University of Hong Kong" },
];
